import { cn } from '@/lib/utils';

export type SenderSegmentOption<T extends string> = {
	value: T;
	label: string;
};

interface SenderSegmentProps<T extends string> {
	options: SenderSegmentOption<T>[];
	value: T;
	onChange: (value: T) => void;
	className?: string;
}

export default function SenderSegment<T extends string>({
	options,
	value,
	onChange,
	className,
}: SenderSegmentProps<T>) {
	const cols = options.length;
	return (
		<div
			className={cn('grid gap-1 rounded-xl bg-muted/30 p-1', className)}
			style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}
			role='tablist'
		>
			{options.map(option => {
				const active = option.value === value;
				return (
					<button
						key={option.value}
						type='button'
						role='tab'
						aria-selected={active}
						className={cn(
							'min-h-11 rounded-lg px-2 text-[15px] transition-colors',
							active
								? 'bg-background text-primary shadow-sm'
								: 'text-muted-foreground',
						)}
						onClick={() => onChange(option.value)}
					>
						{option.label}
					</button>
				);
			})}
		</div>
	);
}
